import { createSelector } from 'reselect';

const selectRegions = (state: any) => state.regions;


export const selectRegionsCurrentItem = createSelector([selectRegions], (regions) => regions.current);

export const selectRegionsListItems = createSelector([selectRegions], (regions) => regions.list);

export const selectRegionsItemById = (itemId: any) =>
    createSelector(selectRegionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRegionsQueryItems = createSelector([selectRegions], (regions) => regions.query);

export const selectRegionsCreatedItem = createSelector([selectRegions], (regions) => regions.create);

export const selectRegionsUpdatedItem = createSelector([selectRegions], (regions) => regions.update);

export const selectRegionsReadItem = createSelector([selectRegions], (regions) => regions.read);

export const selectRegionsDeletedItem = createSelector([selectRegions], (regions) => regions.delete);

export const selectRegionsSearchedItems = createSelector([selectRegions], (regions) => regions.search);

export const selectRegionsItemsCount = createSelector([selectRegions], (regions) => regions.count);

export const selectRegionsItemsFilter = createSelector([selectRegions], (regions) => regions.filter);